// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';
import dayjs from 'dayjs';

export default class FormListView extends JQueryView {
  establishAt: string;
  canSeeShareTypeFiledResolutions: Array<string>;
  company_procedure_id: string;

  constructor(
    establishAt: string,
    canSeeShareTypeFiledResolutions: Array<string>,
    company_procedure_id: string,
  ) {
    super('.simple_form');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    this.establishAt = establishAt;
    this.canSeeShareTypeFiledResolutions = canSeeShareTypeFiledResolutions;
    this.company_procedure_id = company_procedure_id;
    this.render();
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        minDate: this.establishAt,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.addClass('form-control-active');
      target.removeClass('is-invalid');
      target.removeClass('focus');
    } else {
      target.removeClass('form-control-active');
    }

    // エクスポート方法を変更する時はプレビューを更新しない。
    if (event.target.id == 'stockholder_lists_form_export_method') return;

    this.updatePreview();
  }

  @on({ event: 'change', selector: '#stockholder_lists_form_resolutions_by' })
  onChangeResolutionsBy(event: any) {
    const target = $(event.target);
    if (this.canSeeShareTypeFiledResolutions.includes(target.val())) {
      $('#share_type_id').removeClass('d-none');
      $('#resolutions_by').removeClass('m-bottom-50');
    } else {
      $('#resolutions_by').addClass('m-bottom-50');
      $('#share_type_id').addClass('d-none');
    }
  }

  @on({ event: 'click', selector: '#export' })
  redirectToCompanyStockholders() {
    $('#button').prop('disabled', true);

    let intervalId;
    intervalId = setInterval(() => {
      if ($.cookie('exported')) {
        clearInterval(intervalId);
        $.ajax({
          type: 'POST',
          url: '/company/stockholder_lists/after_download',
          data: {
            company_procedure_id: this.company_procedure_id,
          },
          dataType: 'json',
        }).then(json => {
          window.location.href = json.redirect_path;
        });
      }
    }, 500);
  }

  updatePreview() {
    $('.spinner').removeClass('d-none');
    $('.simple_form').attr('data-remote', 'true');
    $('#preview_button').click();
    $('.simple_form').attr('data-remote', 'false');
  }

  render() {
    this.initDateRangePicker(this.$el);
  }
}
